import { HeaderRowData } from '../../card--my-coaching-card/models/header-row-data.model';
import { SystemComponent } from '../../insight/config.insight.model';
import { PerformanceCard } from '../models/performance-card.model';

import { transformDate } from './get-period-compare-dialog-data.function';

// TODO decouple HeaderRowData from coaching-card
export function getPerformanceHeaderData(
    card: PerformanceCard,
    user: string,
): HeaderRowData {
    return {
        titleLabel:
            card.component === SystemComponent.HUMAN_INSIGHT
                ? user
                : card.name ?? card.shortName,
        periodDate: transformDate(
            {
                periodType: card.periodTypeId,
                startDate: card.startDate,
                endDate: card.endDate,
            },
            card.periodTypeId,
        ),
        hasHeaderIcon: true,
        isHumanView: card.component !== SystemComponent.HUMAN_INSIGHT, // TODO revise. ui component is inversed
    };
}
